import { Button, DataSource, Label, Layout, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopMatchProfile extends Layout {
    buttonAddDetail: Button;
    buttonSearchDetails: Button;
    labelTopMatchDetail: Label;
    sourceTopmatchProfile: DataSource;
    sourceTopmatchProfileDetails: DataSource;
    switchIsActive: Switch;
    tableProfileDetails: Table;
    textboxDescr: Textbox;
    textboxProfileName: Textbox;
    textboxSearchResultsMaximum: Textbox;
    textboxWeight: Textbox;
}
